<template>
   <div>
    <b-modal size="xl" :ok-title="$t('Shared.Posted')" :cancel-title="$t('Shared.BtnCancel')" 
      :id="ModalId" :visible="true" centered scrollable no-close-on-backdrop no-close-on-esc :title="TitleWinLocal" 
      @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" style="max-height:400px !important;"> 
        
<MdTitle v-if="this.ErrorPost" v-bind:Text="$t('PostPayment.ErrorPostModal')" v-bind:isSubtitle="true" v-bind:StyleProp="'margin: -1em 0 0.7em 0'"/>
      <b-row v-if="this.ErrorPost">
          <b-col lg="12" md="12" sm="12">
            <MdMemo
                v-bind:Name="'body'"
                v-bind:Rows="'5'"
                v-bind:MaxRows="'250'" 
                v-bind:isReadOnly="true"          
                v-model="this.ErrorPost"
            />   
          </b-col> 
      </b-row>
      

      
       <Loading v-bind:IsLoading="this.Load" />  
      
      <MdTitle v-bind:StyleProp="this.ErrorPost === '' ? 'margin: -1em 0 0.7em 0' :''" v-bind:Text="$t('ExceptionDetailsPopup.CExceptions')" v-bind:isSubtitle="true" />
                <MdTableClientPag
                  :items="exceptions"
                  :showMessageIsEmpty="ShowMessageIsEmpty"
                  :sticky-header="true"
                  v-bind:totalRows="totalRowsEx"               
                  v-bind:currentPage="currentPageEx"
                  v-bind:perPage="perPageEx"
                  v-bind:pageOptions="pageOptionsEx"
                  :onRowSelected="onExceptionSelected"
                  :fields="exceptionsField"
                  :RowClick="RowClickException"
                  :pageChanged="pageChangedEx"
                  :perPageFunction="PerPageFunctionEx"

                />

                <MdTitle v-bind:Text="$t('ExceptionDetailsPopup.CDetails')" v-bind:isSubtitle="true"/>
                <div class="mt-2">
                <MdTableClientPag
                  :items="claimItems"
                  :showMessageIsEmpty="ShowMessageIsEmptyClaim"
                  :sticky-header="true"
                  :fields="claimFields"
                  :RowClick="RowClickClaim"
                  v-bind:VisibleViewIcon="true"
                  :onRowSelected="onClaimSelected"
                  :viewIconEvent="ViewIcon"
                  :no-select-on-click="true"
                />              
            </div>
           
    </b-modal>   
   </div>
</template>

<script>
//import Utils from '@/common/utils'
import ShowMessage from '@/components/messages/ShowMessage.js'
import PostPaymentService from '@/services/postPayment.service'
import Loading from '@/components/template/loading/Loading'
import Utils from "@/common/utils";


export default {
  name: 'ModalPostPaymentError',
  mixins: [ShowMessage], 
   components: {
    Loading
  }, 
  props: {
    ModalId: String,
    PaymentId:String,
    ErrorPost:String,
    TitleWindow: String 
  },
  
  data(){
    return {
      Load:false,
      exceptions:[],
      expList:[],
      TitleWinLocal : this.TitleWindow,
      ShowMessageIsEmpty:false,
      claimItems:[], 
      totalRowsEx:0,
      currentPageEx:1,
      perPageEx:5,
      pageOptionsEx:[5,10,15],
      exceptionSelectedId:null,   
      HeaderEx:{}, 
      ShowMessageIsEmptyClaim:true,
       claimFields: [
              { key: 'issLineNo', sortable: true, label: this.$t('PostPayment.IssLineNo'), class: 'text-center' },
              { key: 'charges', sortable: true, label: this.$t('HouseFile.Charges'), class: 'text-rigth' },
              { key: 'recID', sortable: true, label: this.$t('ID'), class: 'text-center hidden' },  
              { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
              { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
              { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
              { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth' },                        
              { key: 'modifier1', sortable: true, label: this.$t('rooms.Modifier1'), class: 'text-rigth' },
              { key: 'modifier2', sortable: true, label: this.$t('rooms.Modifier2'), class: 'text-rigth' },             
            ],
       exceptionsField: 
            [
              { key: 'issLineNo', sortable: true, label: this.$t('PostPayment.Line'), class: 'text-center' },
              { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
              { key: 'recID', sortable: true, label: this.$t('ID'), class: 'text-center hidden' },

              { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
              { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },  

              { key: 'abLineNo', sortable: true, label: this.$t('PostPayment.ABLineNo'), class: 'text-rigth' },
              { key: 'claimID', sortable: true, label: this.$t('Claim ID'), class: 'text-rigth' },         
              { key: 'unit', sortable: true, label: this.$t('HouseFile.Unit'), class: 'text-rigth' },
              { key: 'charges', sortable: true, label: this.$t('HouseFile.Charges'), class: 'text-rigth' },
              { key: 'revenueCode', sortable: true, label: this.$t('PostPayment.ReCodCPT'), class: 'text-rigth' },
              { key: 'hcpc', sortable: true, label: this.$t('PostPayment.HCPCSCode'), class: 'text-rigth' },
              { key: 'modifier1', sortable: true, label: this.$t('rooms.Modifier1'), class: 'text-rigth' },
              { key: 'modifier2', sortable: true, label: this.$t('rooms.Modifier2'), class: 'text-rigth' },
             // { key: 'paymentID', sortable: true, label: this.$t('PostPayment.PayID'), class: 'text-rigth' },       
              { key: 'insuranceCode', sortable: true, label: this.$tc('Insurance.Insurance'), class: 'text-rigth' },
              { key: 'policyNo', sortable: true, label: this.$t('Insurance.PolicyNo'), class: 'text-rigth' },
            ],
    }
  },

  methods:{

    RowClickException(){

    },

    RowClickClaim(){

    },

    pageChangedEx(page){
        this.currentPageEx = page;
    },

    PerPageFunctionEx(perpage){
        this.perPageEx = perpage;              
        this.currentPageEx = 1;  
    },

    onExceptionSelected(items){     
      if(items.length === 0){
        this.ShowMessageIsEmptyClaim = true;
        this.claimItems = [];
        return;
      }     
      this.GetEraClaimsAsync(items);
    },

    onClaimSelected(){

    },


    UpdateLineNo(No){
      if(this.exceptionSelectedId !== null){
        this.exceptions.forEach(element => {
          if(element.recID === this.exceptionSelectedId){
            element.issLineNo = No;
          }
        });
      }
    },

    ViewIcon(item){      
      this.UpdateLineNo(item.issLineNo);
    },

     async GetEraClaimsAsync(item){
             /* console.log(item)
              if(item.length == 0){
                this.exceptionSelectedId = null;
                this.claimItems = [];
                return
              }*/
              this.Load = true; 
             // this.selectedException = item
             // console.log(item)

              this.exceptionSelectedId = item[0].recID;
              let params = {
                PatientCode: item[0].patientCode,
                DateFrom: Utils.formatterToISO(item[0].dateFrom),
              }
              await PostPaymentService.getEraClaims(params).then(response => {
                this.Load = false; 
               // console.log(response.data)
                response.data.forEach(element => {
                 // element.dateFrom = new Date(element.dateFrom).toLocaleDateString()
                 // element.dateTo = new Date(element.dateTo).toLocaleDateString()
                  element.datefrom = element.datefrom ? Utils.formatterDateToString(element.datefrom) : null;
                  element.dateto = element.dateto ? Utils.formatterDateToString(element.dateto) : null;
                  element.charges = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.charges)
                })
                this.claimItems = response.data;

               
                this.ShowMessageIsEmptyClaim = this.claimItems.length === 0 ? true : false;
               
                
              }).catch(error => {
                  this.Load = false; 
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      if(error.response.data == undefined){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }
                      else {
                        this.showMessage(this.$tc('Msg.Error'),error.response.data,"error");
                      }
                  }
              })
            },


            CreateListExp(){
              this.expList = [];
              for (let i = 0; i < this.exceptions.length; i++) {
                    this.expList.push({recId:this.exceptions[i].recID,lineNo:this.exceptions[i].issLineNo});            
              }
            },

            async PostPayment() {            
               this.Load = true; 
               this.CreateListExp();
                let data = {
                  "PaymentID": this.PaymentId,
                  "exceptions":this.expList
                }
                await PostPaymentService.postPayment(data).then(response => {
                  console.log(response);
                  /*if(response.status == '200') {
                     this.GetPaymentFilteredList();  
                  }*/
                 /* if(response.data.systemErrors){
                   this.ErrorPost = response.data.systemErrors.replaceAll(/\r\n/g, '\n');
                  }  */       
                 
                  this.Load = false; 
                }).catch(error => {
                    this.Load = false;                   
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                })
              },

     async GetExceptions() {
      this.Load = true; 
          let params = {
         //   PageSize:  this.perPageEx,
         //   PageNumber : this.currentPageEx,  
            PaymentId: this.PaymentId
          }
              await PostPaymentService.getException(params).then(response => {
                this.Load = false; 
                this.exceptions = response.data;

                 /*let headerString = response.headers["x-pagination"];
                 this.HeaderEx = JSON.parse(headerString);*/
                 this.totalRowsEx = this.exceptions.length;    

                this.exceptions.forEach(element => {
                  //element.dateFrom = new Date(element.dateFrom).toLocaleDateString()
                  element.dateFrom = element.dateFrom ? Utils.formatterDateToString(element.datefrom) : null;
                  element.charges = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.charges)
                });              
               this.ShowMessageIsEmpty = this.exceptions.length === 0 ? true : false;
              }).catch(error => {
                this.exceptions = [];
                this.ShowMessageIsEmpty = true;
                 this.Load = false; 
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      if(error.response.data == undefined){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }
                      else {
                        this.showMessage(this.$tc('Msg.Error'),error.response.data,"error");
                      }
                  }
                })

            },

         
    async emitEventOK(bvModalEvent){
      bvModalEvent.preventDefault();        
      await this.PostPayment();    
      this.$emit('getCodeConditionOK',true);         
        //this.$emit('getCodeConditionOK',true); 

      //  bvModalEvent.preventDefault();      
    },
      
    emitEventCancel(){
      this.$emit('getCodeConditionCANCEL');
    }, 

   

    
  },

  mounted(){
    this.GetExceptions();
  },
};
</script>